import { useId } from 'preact/hooks';

/** The AreCoin logo (option B, user choice 2026-10-01): a gold-rimmed coin with Areena's emblem. */
export function CoinIcon(props: { size?: number; class?: string }) {
  const id = useId();
  const size = props.size ?? 18;
  return (
    <svg class={`coin-icon ${props.class ?? ''}`} viewBox="0 0 48 48" width={size} height={size} aria-hidden="true">
      <defs>
        <linearGradient id={`${id}r`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="#fde68a" />
          <stop offset="0.5" stop-color="#ca8a04" />
          <stop offset="1" stop-color="#fde68a" />
        </linearGradient>
        <linearGradient id={`${id}g`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="#5cc8ff" />
          <stop offset="1" stop-color="#a78bfa" />
        </linearGradient>
      </defs>
      <circle cx="24" cy="24" r="23" fill={`url(#${id}r)`} />
      <circle cx="24" cy="24" r="19.5" fill="#1b2442" />
      <path d="M30.5 7.8A16.6 16.6 0 1 1 17.5 7.8" fill="none" stroke={`url(#${id}g)`} stroke-width="3.2" stroke-linecap="round" transform="translate(0,1)" />
      <path d="M24 13 L16.5 34 M24 13 L31.5 34" stroke="#e8ecf6" stroke-width="3.4" stroke-linecap="round" fill="none" />
      <path d="M24 22.6l1.3 2.7 3 .3-2.3 2 .7 3-2.7-1.6-2.7 1.6.7-3-2.3-2 3-.3z" fill="#facc15" />
    </svg>
  );
}

/** "1 250" with the coin. */
export function Coins(props: { amount: number; size?: number; class?: string }) {
  return (
    <span class={`coins ${props.class ?? ''}`}>
      <CoinIcon size={props.size} />
      {props.amount.toLocaleString('fi-FI')}
    </span>
  );
}
